(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["galore-product"]) return;
  try {
    
(() => {
  'use strict';
  function init(scope) {
    scope.querySelectorAll('[data-cgp-root]').forEach((root) => {
      if (root.dataset.cgpReady) return;
      root.dataset.cgpReady = 'true';
      const form = root.querySelector('form.cgp-form');
      const configNode = root.querySelector('[data-cgp-config]');
      if (!form || !configNode) return;
      let config;
      try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
      const variantInput = form.querySelector('[name="id"]');
      const quantity = form.querySelector('[name="quantity"]');
      const status = root.querySelector('[data-cgp-status]');
      const buttons = [...root.querySelectorAll('[data-cgp-submit]')];
      const slides = [...root.querySelectorAll('[data-cgp-slide]')];
      const thumbs = [...root.querySelectorAll('[data-cgp-thumb]')];
      const lightbox = root.querySelector('[data-cgp-lightbox]');
      let activeIndex = Math.max(0, slides.findIndex((slide) => !slide.hidden));
      let busy = false;
      const selected = () => config.variants.find((variant) => String(variant.id) === variantInput.value);
      function updateButtons() {
        const variant = selected();
        buttons.forEach((button) => {
          button.disabled = busy || !variant || !variant.available;
          button.textContent = busy ? config.adding : variant && variant.available ? config.add : config.soldOut;
          button.setAttribute('aria-busy', String(busy));
        });
      }
      function showMedia(index) {
        if (!slides.length) return;
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          if (i !== activeIndex && !slide.hidden) {
            slide.querySelectorAll('video').forEach((video) => video.pause());
            slide.querySelectorAll('iframe').forEach((frame) => { const src = frame.getAttribute('src'); if (src) frame.setAttribute('src', src); });
          }
          slide.hidden = i !== activeIndex;
        });
        thumbs.forEach((thumb) => thumb.setAttribute('aria-pressed', String(thumb.dataset.cgpThumb === slides[activeIndex].dataset.mediaId)));
        const count = root.querySelector('[data-cgp-count]');
        if (count) count.textContent = `${activeIndex + 1} / ${slides.length}`;
      }
      root.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;
        const thumb = event.target.closest('[data-cgp-thumb]');
        if (thumb) showMedia(slides.findIndex((slide) => slide.dataset.mediaId === thumb.dataset.cgpThumb));
        if (event.target.closest('[data-cgp-prev]')) showMedia(activeIndex - 1);
        if (event.target.closest('[data-cgp-next]')) showMedia(activeIndex + 1);
        const step = event.target.closest('[data-cgp-quantity]');
        if (step && !busy) {
          const value = Number.parseInt(quantity.value, 10);
          quantity.value = String(Math.max(1, (Number.isFinite(value) ? value : 1) + Number(step.dataset.cgpQuantity)));
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const zoom = event.target.closest('[data-cgp-zoom]');
        if (zoom && lightbox && typeof lightbox.showModal === 'function') {
          const large = lightbox.querySelector('[data-cgp-lightbox-image]');
          large.src = zoom.dataset.cgpZoom;
          large.alt = zoom.querySelector('img')?.alt || '';
          lightbox.showModal();
        }
        if (event.target.closest('[data-cgp-close]')) lightbox.close();
      });
      if (lightbox) lightbox.addEventListener('click', (event) => { if (event.target === lightbox) lightbox.close(); });
      const gallery = root.querySelector('[data-cgp-gallery]');
      if (gallery) gallery.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); showMedia(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      variantInput.addEventListener('change', () => {
        const variant = selected();
        if (!variant) { updateButtons(); return; }
        root.querySelector('[data-cgp-price]').textContent = variant.price;
        root.querySelector('[data-cgp-sticky-price]').textContent = variant.price;
        const compare = root.querySelector('[data-cgp-compare]');
        compare.textContent = variant.compare; compare.hidden = !variant.sale;
        const saving = root.querySelector('[data-cgp-saving]');
        saving.textContent = variant.saving; saving.hidden = !variant.sale;
        root.querySelector('[data-cgp-stock-text]').textContent = variant.stock;
        root.querySelector('[data-cgp-stock]').dataset.available = String(variant.available);
        const mediaIndex = slides.findIndex((slide) => slide.dataset.mediaId === String(variant.mediaId));
        if (mediaIndex >= 0) showMedia(mediaIndex);
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
        history.replaceState(null, '', url);
        status.textContent = '';
        updateButtons();
      });
      form.addEventListener('submit', async (event) => {
        if (!window.fetch || !window.FormData) return;
        event.preventDefault();
        if (busy || !selected()?.available || !form.reportValidity()) return;
        const chosenQuantity = Number(quantity.value);
        if (!Number.isInteger(chosenQuantity) || chosenQuantity < 1) { quantity.focus(); return; }
        busy = true; updateButtons(); status.textContent = ''; status.dataset.error = 'false';
        let confirmed = false;
        try {
          const response = await fetch(root.dataset.addUrl, { method: 'POST', headers: { Accept: 'application/json' }, credentials: 'same-origin', body: new FormData(form) });
          let data;
          try { data = await response.json(); } catch (_) { throw new Error(config.uncertain); }
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : config.error);
          confirmed = true;
          status.textContent = config.added;
          if (typeof window.cgToast === 'function') window.cgToast(config.added);
          const drawerTrigger = document.querySelector('[data-cart-open]');
          if (drawerTrigger) drawerTrigger.click(); else window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          status.dataset.error = 'true';
          status.textContent = confirmed ? config.added : error instanceof TypeError ? config.uncertain : error.message || config.error;
        } finally { busy = false; updateButtons(); }
      });
      const sticky = root.querySelector('[data-cgp-sticky]');
      const breakpoint = window.matchMedia('(max-width: 600px)');
      let scrolledPast = false;
      function syncSticky() {
        if (!sticky) return;
        const visible = breakpoint.matches && scrolledPast;
        sticky.hidden = !visible;
        document.body.classList.toggle('cgp-sticky-visible', visible);
      }
      let scrollFrame = 0;
      function measureSticky() {
        scrollFrame = 0;
        scrolledPast = form.getBoundingClientRect().bottom < 0;
        syncSticky();
      }
      function queueSticky() {
        if (!scrollFrame) scrollFrame = requestAnimationFrame(measureSticky);
      }
      window.addEventListener('scroll', queueSticky, { passive: true });
      window.addEventListener('resize', queueSticky, { passive: true });
      breakpoint.addEventListener('change', queueSticky);
      queueSticky();
      root.cgpDestroy = () => {
        if (scrollFrame) cancelAnimationFrame(scrollFrame);
        window.removeEventListener('scroll', queueSticky);
        window.removeEventListener('resize', queueSticky);
        breakpoint.removeEventListener('change', queueSticky);
        document.body.classList.remove('cgp-sticky-visible');
      };
      showMedia(activeIndex); updateButtons();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true }); else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-cgp-root]').forEach((root) => root.cgpDestroy?.()));
})();


  } catch(e) { console.error(e); }
})();
})();
